<template>
  <ShImage class="image" alt='image' aspect-ratio="1/1" :src="imageSrc" />
</template>

<script>
import { ShImage } from '@sohohouse/design-system'

const nullImages = {
  default: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/default.png',
  search: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/search.png',
  calendar: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/calendar.png',
  computer: 'https://res.cloudinary.com/soho-house/image/upload/f_auto,q_auto/v1593597890/digital-house-web/computer.png'
}

export default {
  name: 'NullStateImage',

  components: {
    ShImage
  },

  props: {
    image: {
      type: String,
      required: false,
      default: 'search',
      validator: value => Object.keys(nullImages).includes(value)
    }
  },

  computed: {
    imageSrc () {
      return nullImages[this.image]
    }
  }
}
</script>


<style lang="scss" scoped>

.image {
  width: 160px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-bottom: $space-060;
}
</style>